module.exports = __webpack_public_path__ + "static/3d-8477d4c8ecb94bc2c89d0f0fb8bc2b22.svg";